import React from "react";

import { ChipProps } from "@mui/material/Chip";
import { colors } from "@zapalacorp/tokens";
import { StarSlash } from "iconsax-react";

import { OrderVipTreatmentMode } from "../../../util/enums";
import { Chip } from "./styled";

const VIP_LETTER_DICTIONARY = {
  [OrderVipTreatmentMode.VIP]: "V",
  [OrderVipTreatmentMode.BLUEBARK]: "B",
  [OrderVipTreatmentMode.SAFETY]: "S",
};

interface VipChipProps extends ChipProps {
  vipTreatment: string;
}

export const VipChip = (props: VipChipProps) => {
  const { vipTreatment, ...rest } = props;

  return (
    <Chip
      label={
        <span>
          <StarSlash size={16} color={colors.rose800} fill={colors.white} variant="Bold" />
          {VIP_LETTER_DICTIONARY[vipTreatment as keyof typeof VIP_LETTER_DICTIONARY]}
        </span>
      }
      size="small"
      variant="outlined"
      {...rest}
    />
  );
};
